export const API_URL = process.env.REACT_APP_API_URL || 'https://green-admin.merket.io/api';

export const VIETNAM_BANKS = [
  { code: 'VCB', name: 'Vietcombank', bin: '970436' },
  { code: 'TCB', name: 'Techcombank', bin: '970407' },
  { code: 'MB', name: 'MB Bank', bin: '970422' },
  { code: 'VTB', name: 'VietinBank', bin: '970415' },
  { code: 'BIDV', name: 'BIDV', bin: '970418' },
  { code: 'ACB', name: 'ACB', bin: '970416' },
  { code: 'STB', name: 'Sacombank', bin: '970403' },
  { code: 'VPB', name: 'VPBank', bin: '970432' },
  { code: 'TPB', name: 'TPBank', bin: '970423' },
  { code: 'AGR', name: 'Agribank', bin: '970405' },
  { code: 'SHB', name: 'SHB', bin: '970443' },
  { code: 'HDB', name: 'HDBank', bin: '970437' },
  { code: 'OCB', name: 'OCB', bin: '970448' },
  { code: 'SEA', name: 'SeABank', bin: '970440' },
  { code: 'LPB', name: 'LienVietPostBank', bin: '970449' },
  { code: 'VIB', name: 'VIB', bin: '970441' },
  { code: 'MSB', name: 'MSB', bin: '970426' },
  { code: 'EIB', name: 'Eximbank', bin: '970431' },
  { code: 'BAB', name: 'Bac A Bank', bin: '970409' },
  { code: 'NAB', name: 'Nam A Bank', bin: '970428' },
  { code: 'NCB', name: 'NCB', bin: '970419' },
  { code: 'KLB', name: 'Kienlongbank', bin: '970452' },
  { code: 'PGB', name: 'PGBank', bin: '970430' },
  { code: 'VAB', name: 'Viet A Bank', bin: '970427' },
  { code: 'SCB', name: 'SCB', bin: '970429' },
  { code: 'CAKE', name: 'CAKE by VPBank', bin: '546034' },
  { code: 'Ubank', name: 'Ubank by VPBank', bin: '546035' },
];

export const STATUS_BADGES = {
  pending: 'bg-yellow-100 text-yellow-800',
  preparing: 'bg-purple-100 text-purple-800',
  completed: 'bg-green-100 text-green-800',
  paid: 'bg-gray-100 text-gray-800',
  cancelled: 'bg-red-100 text-red-800'
};

export const STATUS_LABELS = {
  pending: 'Chờ xác nhận',
  preparing: 'Đang làm',
  completed: 'Hoàn thành',
  paid: 'Đã thanh toán',
  cancelled: 'Đã hủy'
};

export const STATUS_LABELS_SHORT = {
  pending: 'Chờ',
  preparing: 'Làm',
  completed: 'Xong',
  paid: 'Paid',
  all: 'All'
};

export const PAYMENT_LABELS = {
  cash: 'Tiền mặt',
  transfer: 'Chuyển khoản',
  debt: 'Ghi nợ'
};

export const FONT_SIZES = {
  small: { body: '12px', shopName: '14px', title: '13px', item: '11px', option: '10px', total: '13px' },
  normal: { body: '14px', shopName: '16px', title: '15px', item: '13px', option: '12px', total: '15px' },
  large: { body: '16px', shopName: '18px', title: '17px', item: '15px', option: '14px', total: '17px' }
};

export const DEFAULT_PRINT_SETTINGS = {
  showLogo: true,
  showQRCode: true,
  showBankInfo: true,
  fontSize: 'normal',
  footerText: 'Cảm ơn quý khách!',
  showTransferNote: true,
  paperWidth: '80mm',
  transferPrefix: ''
};
